<div style="height: 100vh; clear: both; padding: 0;" class="section md-hero ">
    <div class="row">
        <div class="col" style="width: 100%;">
            <ng-container #container></ng-container>
        </div>
    </div>
  </div>